import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, NgModule, OnInit, ViewEncapsulation } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { WINDOW } from '@app/common/app-tokens';
import { Roles } from '@app/common/roles';
import { Utilities } from '@app/common/utilities';
import { ToolbarButtonModule } from '@app/components/header/toolbar-button/toolbar-button.component';
import { LinkModule } from '@app/directives/link.directive';
import { SafeModule } from '@app/pipes/safe.pipe';
import { AuthService } from '@app/services/auth.service';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';
import { FeatureToggleModule } from '@app/directives/feature-toggle.directive';
import { SecurityService } from '@app/services/security.service';
import { UserService } from '@app/services/user.service';
import { User } from '@microsoft/microsoft-graph-types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { InfoboxService } from '@app/services/infobox.service';
import { NgSubscribeModule } from '@app/directives/ng-subscribe.directive';
import { PersonExtended } from '@app/models/person-extended';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserMenuComponent implements OnInit {

  userProfile$: Observable<PersonExtended>;
  hasPermissionEditorOrAdmin$: Observable<boolean>;
  hasPermissionEditorOrAdminOrDashBoard$: Observable<boolean>;
  hasPermissionAdmin$: Observable<boolean>;
  enableMyProfile: boolean;
  userUpn: string;
  infoboxZones = [];
  anyInfoBoxesOnPage: boolean;
  editModeInfoBoxes$ = this.infoboxService.currentEditMode$;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private userService: UserService,
    private authService: AuthService,
    private securityService: SecurityService,
    private infoboxService: InfoboxService,
    private featureStoreSettingsService: FeatureSettingsStoreService,
    @Inject(WINDOW) private window: Window,
    private router: Router) { }

  getPictureUrl(userProfile: User): Observable<string> {
    return this.userService.getUserPhotoByUpn(userProfile.userPrincipalName);
  }

  getPreferredNameLetters(userProfile: User) {
    return Utilities.generateInitials(userProfile.displayName);
  }

  logOut() {
    this.authService.logOut();
  }

  menuOpened() {

    this.window.setTimeout(() => {
      const element = this.document.getElementById('btn-infobox');
      if (element) {
       element.focus();
      }
    }, 100);

    this.anyInfoBoxesOnPage = this.document.getElementsByTagName('app-infobox-zone').length > 0;
    // For find infomration route, since the section is hidden so app-infobox-zone is still avialable in the DOM
    if ( this.router.url.indexOf('find-information') >= 0) {
      this.anyInfoBoxesOnPage = this.featureStoreSettingsService.state.enableRightSection;
    }
  }

  showInfoBoxZones(event: any) {
    if (event.keyCode === 39) {
      event.checked = true;
    }
    if (event.keyCode === 37) {
      event.checked = false;
    }
    this.infoboxService.currentEditMode$.next(event.checked);
  }

  goToDelve(user: PersonExtended) {
    this.window.location.href = `https://delve.office.com/?u=${user.id}`;
  }

  ngOnInit() {
    this.enableMyProfile = this.featureStoreSettingsService.state.enableProfileCardView;

    this.userProfile$ = this.userService.getMyDetailsFromMsGraph()
      .pipe(
        map(user => {
          const re = /\./gi;
          this.userUpn = user.userPrincipalName.replace(re, '/');
          return user;
        }));

    this.hasPermissionEditorOrAdmin$ = this.securityService.hasUserAnyAppRole([Roles.Admin, Roles.Editor]);
    this.hasPermissionEditorOrAdminOrDashBoard$ = this.securityService.hasUserAnyAppRole([Roles.Admin, Roles.Editor, Roles.EditorDashboardEditor]);
    this.hasPermissionAdmin$ = this.securityService.hasUserAppRole(Roles.Admin);
  }

}
@NgModule({
  declarations: [UserMenuComponent],
  exports: [UserMenuComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    RouterModule,
    LinkModule,
    ToolbarButtonModule,
    SafeModule,
    MatSlideToggleModule,
    NgSubscribeModule,
    FeatureToggleModule
  ]
})
export class UserMenuModule { }
